import { render, staticRenderFns } from "./usercsLog.vue?vue&type=template&id=284b8e24&scoped=true&"
import script from "./usercsLog.vue?vue&type=script&lang=js&"
export * from "./usercsLog.vue?vue&type=script&lang=js&"
import style0 from "./usercsLog.vue?vue&type=style&index=0&id=284b8e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b8e24",
  null
  
)

export default component.exports